<div class="medium-management-dialog-container">
	<div class="d-flex justify-content-between align-items-center">
		<span class="title" mat-dialog-title>{{ ('BUTTON.' + data.mode | translate) + ' ' + (data.type + '.TITLE' | translate) }}</span>
		<button mat-icon-button (click)="closeDialog()" class="d-flex justify-content-center align-items-center me-4">
			<mat-icon>close</mat-icon>
		</button>
	</div>

	<mat-dialog-content class="m-0 p-3">
		@if (data.mode === 'NEW' || data.mode === 'EDIT') {
		<form [formGroup]="formGroup" (keydown.enter)="action()">
			<div class="row">
				<mat-form-field class="pb-3">
					<mat-label>{{ data.type + '.NAME_CYRILLIC' | translate }}</mat-label>
					<input matInput type="text" formControlName="nameCyrillic" cdkFocusInitial />
					<!-- <mat-icon
						class="cursor-pointer"
						matTooltip="{{ 'ASSORTED.TRANSLITERATE' | translate }}"
						matTooltipPosition="below"
						matSuffix
						(click)="transliterate('nameCyrillic', 'nameLatin', 'CYR_LAT')"
						>move_down</mat-icon
					> -->
				</mat-form-field>
			</div>

			<div class="row">
				<mat-form-field class="pb-3">
					<mat-label>{{ data.type + '.NAME_LATIN' | translate }}</mat-label>
					<input matInput type="text" formControlName="nameLatin" />
					<mat-icon
						class="cursor-pointer"
						matTooltip="{{ 'ASSORTED.TRANSLITERATE' | translate }}"
						matTooltipPosition="below"
						matSuffix
						(click)="transliterate('nameLatin', 'nameCyrillic', 'LAT_CYR')"
						>move_up</mat-icon
					>
				</mat-form-field>
			</div>

			<div class="row">
				<mat-form-field class="pb-3">
					<mat-label>{{ 'CLIPS.MEDIUM_TYPE' | translate }}</mat-label>
					<select id="type" style="display: none"></select>
					<!-- workaround for material-chrome bug -->
					<mat-select id="type" placeholder="{{ 'ASSORTED.SELECT_OPTION' | translate }}" formControlName="type">
						@for (type of mediumTypes; track $index) {
						<mat-option [value]="type">{{ 'MEDIUM.TYPES.' + type | translate }}</mat-option>
						}
					</mat-select>
				</mat-form-field>
			</div>

			@if(data.typeWithScope === 'medium_clipping'){
			<div class="row">
				<mat-form-field class="pb-3">
					<mat-label>{{ 'MEDIUM.LANGUAGE' | translate }}</mat-label>
					<select id="lang" style="display: none"></select>
					<!-- workaround for material-chrome bug -->
					<mat-select id="lang" placeholder="{{ 'ASSORTED.SELECT_OPTION' | translate }}" formControlName="lang">
						@for (lang of langOptions; track $index) {
						<mat-option [value]="getLangCode(lang)">{{ lang.name | translate }}</mat-option>
						}
					</mat-select>
				</mat-form-field>
			</div>
			}

			@if(data.typeWithScope === 'medium_clipping'){
			<mat-form-field floatLabel="always" class="w-100 ps-1 pb-2">
				<mat-label>{{ 'MEDIUM.IMAGE' | translate }}</mat-label>
				<input type="text" matInput formControlName="mediaUrl" readonly />
				<button class="me-1" mat-icon-button matSuffix type="button" (click)="fileInput.click()" aria-label="Choose file">
					<mat-icon color="primary">upload</mat-icon>
				</button>
				<input hidden (change)="selectFilesForUpload($event)" [accept]="getAcceptedFileFormats()" #fileInput type="file" id="file" />
			</mat-form-field>

			<div class="row">
				<mat-form-field class="pb-3">
					<mat-label>{{ data.type + '.SITE_VISITS' | translate }}</mat-label>
					<input matInput type="number" formControlName="siteVisits" />
				</mat-form-field>
			</div>

			<div class="row">
				<mat-form-field class="pb-3">
					<mat-label>{{ data.type + '.FB_FOLLOWERS' | translate }}</mat-label>
					<input matInput type="number" formControlName="facebookFollowers" />
				</mat-form-field>
			</div>

			<div class="row">
				<mat-form-field class="pb-3">
					<mat-label>{{ data.type + '.FB_LINK' | translate }}</mat-label>
					<input matInput type="text" formControlName="facebookLink" />
				</mat-form-field>
			</div>

			<div class="row">
				<mat-form-field class="pb-3">
					<mat-label>{{ data.type + '.COMMERCIAL_VALUE' | translate }}</mat-label>
					<input matInput type="number" formControlName="commercialValue" />
				</mat-form-field>
			</div>

			@if (isRecordingScheduleCapable()) {
			<div class="row">
				<mat-form-field class="pb-3">
					<mat-label>{{ data.type + '.IPTV_URL' | translate }}</mat-label>
					<input matInput type="text" formControlName="iptvUrl" (input)="iptvProbeResult = null" />
					<button
						mat-stroked-button
						matSuffix
						type="button"
						class="me-2"
						(click)="probeIptv()"
						[disabled]="iptvProbeLoading || !formGroup.get('iptvUrl')?.value"
						matTooltip="{{ 'MEDIUM.IPTV_PROBE_TOOLTIP' | translate }}">
						@if (iptvProbeLoading) {
						<mat-spinner diameter="16"></mat-spinner>
						} @else {
						{{ 'MEDIUM.IPTV_PROBE' | translate }}
						}
					</button>
					@if (iptvProbeResult) {
					<mat-hint [class.probe-ok]="iptvProbeResult.ok" [class.probe-error]="!iptvProbeResult.ok">
						@if (iptvProbeResult.ok) {
						✔ {{ 'MEDIUM.IPTV_PROBE_OK' | translate }}@if (iptvProbeResult.hasAudio) { {{ 'MEDIUM.IPTV_PROBE_AUDIO' | translate }}}.
						@if (iptvProbeResult.message) { {{ iptvProbeResult.message }} }
						} @else {
						✖ {{ iptvProbeResult.message }}
						}
					</mat-hint>
					}
				</mat-form-field>
			</div>

			<!-- В1: subscription is no longer a manual field - it is recognized from the IPTV
			link's username (IptvUrlUtils) and shown as the Gantt chart's block colour below. -->

			<mat-divider class="mb-3"></mat-divider>

			<div class="pb-2">
				<span class="font-weight-bold">{{ data.type + '.RECORDING_SCHEDULES' | translate }}</span>
			</div>

			@if (data.mode !== 'EDIT') {
			<p class="pb-3">{{ data.type + '.SAVE_MEDIUM_FIRST_FOR_SCHEDULES' | translate }}</p>
			} @else {
			@if (recordingSchedulesLoading) {
			<div class="d-flex justify-content-center pb-3">
				<mat-spinner diameter="24"></mat-spinner>
			</div>
			} @else {
			@for (schedule of recordingScheduleControls; track $index) {
			<div class="row align-items-start pb-2" [formGroup]="schedule">
				<app-time-field class="col-3 pe-1" [label]="data.type + '.START_TIME' | translate" formControlName="startTime"></app-time-field>

				<mat-form-field class="col-2 pe-1">
					<mat-label>{{ data.type + '.DURATION_MINUTES' | translate }}</mat-label>
					<input matInput type="number" min="1" formControlName="durationMinutes" />
				</mat-form-field>

				<mat-form-field class="col-3 pe-1">
					<mat-label>{{ data.type + '.DAYS_OF_WEEK' | translate }}</mat-label>
					<select style="display: none"></select>
					<!-- workaround for material-chrome bug -->
					<mat-select multiple formControlName="daysOfWeek">
						@for (day of daysOfWeek; track $index) {
						<mat-option [value]="day">{{ data.type + '.DAYS.' + day | translate }}</mat-option>
						}
					</mat-select>
				</mat-form-field>

				<div class="col-1 d-flex align-items-center pe-1">
					<mat-checkbox color="primary" [checked]="isAllDaysSelected($index)" (change)="toggleAllDays($index)" matTooltip="{{ data.type + '.SELECT_ALL_DAYS' | translate }}">
					</mat-checkbox>
				</div>

				<div class="col-1 d-flex align-items-center pe-1">
					<mat-checkbox color="primary" formControlName="enabled" matTooltip="{{ data.type + '.ENABLED' | translate }}"> </mat-checkbox>
				</div>

				<div class="col-2 d-flex align-items-center justify-content-end">
					<button
						mat-icon-button
						color="primary"
						type="button"
						[disabled]="schedule.invalid || scheduleRowSaving[$index]"
						matTooltip="{{ 'BUTTON.SAVE' | translate }}"
						(click)="saveScheduleRow($index)">
						@if (scheduleRowSaving[$index]) {
						<mat-spinner diameter="18"></mat-spinner>
						} @else {
						<mat-icon>check</mat-icon>
						}
					</button>
					<button mat-icon-button color="warn" type="button" matTooltip="{{ 'BUTTON.DELETE' | translate }}" (click)="removeScheduleRow($index)">
						<mat-icon>close</mat-icon>
					</button>
				</div>
			</div>
			}

			<button mat-stroked-button color="primary" type="button" class="mb-3" (click)="addScheduleRow()">
				<mat-icon class="me-1">add</mat-icon>
				{{ data.type + '.ADD_SCHEDULE' | translate }}
			</button>
			}
			}
			}
			}
		</form>

		} @else if (data.mode === 'DELETE') {
		<span> {{ 'ASSORTED.DELETE_CONFIRMATION_MESSAGE' | translate }} {{ utils.getParameterByLanguageScript(data.item, 'name') }}? </span>
		} @else if (data.mode === 'DELETE_REASSIGN') {
		<div class="pb-2">
			<span> {{ 'ASSORTED.DELETE_CONFIRMATION_MESSAGE' | translate }} {{ utils.getParameterByLanguageScript(data.item, 'name') }}? </span>
			<br />
			<span> {{ utils.getParameterByLanguageScript(data.item, 'name') }} {{ data.type + '.DELETE_RELATED_WITH_CLIPS' | translate }} ( {{ itemRelatedClips }} ) </span>
		</div>

		<form [formGroup]="formGroup" class="row">
			<mat-form-field>
				<mat-label>{{ 'ASSORTED.SELECT_OPTION' | translate }}</mat-label>
				<input type="text" matInput formControlName="reassignTo" [matAutocomplete]="mediumAutocomplete" [readonly]="formGroup.controls['reassign'].value" />
				<mat-autocomplete #mediumAutocomplete="matAutocomplete" [displayWith]="displayFn.bind(this)">
					@for (filteredItem of filteredMediums; track $index) {
					<mat-option [value]="filteredItem">{{ utils.getParameterByLanguageScript(filteredItem, 'name') }}</mat-option>
					}
				</mat-autocomplete>
			</mat-form-field>

			<div class="row pb-0">
				<mat-checkbox class="mt-2" color="primary" formControlName="reassign">
					<span>{{ data.type + '.REASSIGN_CONFIRMATION' | translate }}</span>
				</mat-checkbox>
			</div>
		</form>
		}
	</mat-dialog-content>

	<mat-dialog-actions [align]="'end'" class="px-3">
		<mat-divider class="w-100 my-2"></mat-divider>
		@if (data.mode === 'DELETE' || data.mode === 'DELETE_REASSIGN') {
		<div class="d-flex justify-content-end pt-0">
			<button
				mat-flat-button
				color="warn"
				(click)="action()"
				[disabled]="data.mode !== 'DELETE' && !(formGroup.controls['reassignTo'].value || formGroup.controls['reassign'].value)">
				{{ 'ASSORTED.YES' | translate }}
			</button>
			<button mat-flat-button color="primary" (click)="closeDialog()">
				{{ 'ASSORTED.NO' | translate }}
			</button>
		</div>
		} @else {
		<button mat-flat-button color="primary" (click)="action()" [disabled]="formGroup.invalid || apiLoading.management">
			<div class="d-flex">
				@if(apiLoading.management) {
				<mat-spinner diameter="15" class="me-1"></mat-spinner>
				}
				<span>{{ 'BUTTON.SAVE' | translate }}</span>
			</div>
		</button>
		}
	</mat-dialog-actions>
</div>
